import { render, staticRenderFns } from "./ShareStock.vue?vue&type=template&id=af750ee6&scoped=true&"
import script from "./ShareStock.vue?vue&type=script&lang=js&"
export * from "./ShareStock.vue?vue&type=script&lang=js&"
import style0 from "./ShareStock.vue?vue&type=style&index=0&id=af750ee6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af750ee6",
  null
  
)

export default component.exports